/**
* Sdk.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2019
*/
import dynamicProto from "@microsoft/dynamicproto-js";
import { getCookieValue, newGuid, onConfigChange, random32 } from "@microsoft/applicationinsights-core-js";
var DEVICE_ID_COOKIE = "MicrosoftApplicationsTelemetryDeviceId";
function _saveData(mgr, propertyStorage, name, value) {
    if (propertyStorage) {
        propertyStorage.setProperty(name, value);
    }
    else {
        // Expires in 365 days (365 * 24 * 60 * 60)
        mgr.set(name, value, 31536000);
    }
}
function _getData(mgr, propertyStorage, name) {
    if (propertyStorage) {
        return propertyStorage.getProperty(name) || "";
    }
    return getCookieValue(mgr, name);
}
var Sdk = /** @class */ (function () {
    function Sdk(coreConfig, core, unloadHookContainer) {
        var _sequenceId = 0;
        var _cookieMgr;
        dynamicProto(Sdk, this, function (_self) {
            // Start sequence
            _self.seq = _sequenceId;
            _self.epoch = random32(false).toString();
            _self.getSequenceId = function () {
                return ++_sequenceId;
            };
            var unloadHook = onConfigChange(coreConfig, function (details) {
                _cookieMgr = core && core.getCookieMgr();
                var coreConfig = details.cfg;
                var propertyStorage = coreConfig.propertyStorageOverride;
                var cookieMgrEnabled = _cookieMgr.isEnabled();
                if (cookieMgrEnabled || propertyStorage) {
                    // Only collect device id if it can be stored
                    var deviceId = _getData(_cookieMgr, propertyStorage, DEVICE_ID_COOKIE);
                    if (!deviceId) {
                        deviceId = newGuid();
                    }
                    _saveData(_cookieMgr, propertyStorage, DEVICE_ID_COOKIE, deviceId);
                    _self.installId = deviceId;
                }
                else {
                    _cookieMgr.purge(DEVICE_ID_COOKIE);
                }
            });
            unloadHookContainer && unloadHookContainer.add(unloadHook);
        });
    }
    // Get seq value
    Sdk.prototype.getSequenceId = function () {
        // @DynamicProtoStub - DO NOT add any code as this will be removed during packaging
        return -1;
    };
    return Sdk;
}());
export { Sdk };
//# sourceMappingURL=Sdk.js.map